import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [isDayMode, setIsDayMode] = useState(() => {
    return localStorage.getItem('opramix-theme') === 'day';
  });

  useEffect(() => {
    localStorage.setItem('opramix-theme', isDayMode ? 'day' : 'night');
    document.documentElement.setAttribute('data-theme', isDayMode ? 'day' : 'night');
  }, [isDayMode]);

  const toggleTheme = () => setIsDayMode(prev => !prev);

  return (
    <ThemeContext.Provider value={{ isDayMode, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);